import type { SchemaBuilderExpressionFormulaProps } from "./schema-builder-expression-formula.type";

import { useTranslation } from "react-i18next";

import { FieldText } from "@/ui/field-text";

import { SchemaBuilderExpressionHint } from "../schema-builder-expression-hint";
import { SchemaBuilderExpressionStatus } from "../schema-builder-expression-status";

import { useSchemaBuilderExpressionFormula } from "./schema-builder-expression-formula.hook";

export const SchemaBuilderExpressionFormula = ({
  name,
  label,
  ...props
}: SchemaBuilderExpressionFormulaProps) => {
  const { t } = useTranslation();
  const { onChange } = useSchemaBuilderExpressionFormula({ name });

  return (
    <FieldText
      name={[name, "formula"]}
      label={label ?? t("schema:expression.label")}
      placeholder={t("schema:expression.placeholder")}
      onChange={(e) => onChange(e.currentTarget.value)}
      extra={<SchemaBuilderExpressionHint />}
      suffix={<SchemaBuilderExpressionStatus name={name} />}
      className="schema-builder-expression-formula"
      {...props}
    />
  );
};
